import React, { Component } from 'react';
import styles from './InviteUserPage.module.scss';
import { LabeledInput, Button, LabeledDropdown } from 'components';
import { User, isEmailValid } from 'utilities';
import { RouteComponentProps } from 'react-router';
import { inject } from 'mobx-react';
import { GENERAL_STORE, GeneralStore, USER_STORE, UserStore, InviteUserPayload } from 'store';
import { PageContainer } from 'pages';

interface Props extends RouteComponentProps {
  [GENERAL_STORE]: GeneralStore;
  [USER_STORE]: UserStore;
}

interface State {
  emailAddress: string;
  organizationName: string;
  organizationId: string;
  errors: {
    email: boolean;
    organization: boolean;
  };
}

class InviteUserPage extends Component<Props, State> {
  organizations: any[];
  dropDownKey: number;

  constructor(props: Props) {
    super(props);

    this.state = {
      emailAddress: '',
      organizationName: '',
      organizationId: '',
      errors: {
        email: false,
        organization: false
      }
    };

    this.organizations = User.getOrganizations();
    this.dropDownKey = 0;

    this.onDropDownSelect = this.onDropDownSelect.bind(this);
    this.handleOrganizationNameChange = this.handleOrganizationNameChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleEmailChange = this.handleEmailChange.bind(this);
  }

  onDropDownSelect(selectedOptions: string[]) {
    const index = this.organizations.findIndex(org => org.name === selectedOptions[0]);
    this.setState({
      organizationId: this.organizations[index].id,
      organizationName: '',
      errors: {
        ...this.state.errors,
        organization: false
      }
    });
  }

  handleOrganizationNameChange(organizationName: string) {
    this.dropDownKey++;
    this.setState({
      organizationName,
      organizationId: '',
      errors: {
        ...this.state.errors,
        organization: false
      }
    });
  }

  handleEmailChange(emailAddress: string) {
    this.setState({
      emailAddress,
      errors: {
        ...this.state.errors,
        email: false
      }
    });
  }

  validateForm(): Promise<void> {
    const { emailAddress, organizationName, organizationId } = this.state;

    return new Promise((resolve, reject) => {
      const errors = { email: false, organization: false };
      let errMessage = '';

      if (!organizationName && !organizationId) {
        errors.organization = true;
        errMessage = 'Please choose existing or provide name of a new organization.';
      }
      if (!isEmailValid(emailAddress)) {
        errors.email = true;
        errMessage = 'Please provide a valid email address.';
      }

      if (errMessage) {
        this.setState(
          { errors },
          () => reject(new Error(errMessage))
        );
      } else {
        resolve();
      }
    });
  }
  

  validateAndSubmit() {
    this.validateForm()
      .then(() => {
        const { emailAddress, organizationId, organizationName } = this.state;
        const payload: InviteUserPayload = { emailAddress };
        if (organizationId) {
          payload.organizationId = organizationId;
        } else {
          payload.organizationName = organizationName;
        }

        this.props[USER_STORE]!.invite(payload);
      })
      .catch(err => this.props[GENERAL_STORE].showError(err.message));
  }

  handleSubmit() {
    this.setState(
      { emailAddress: this.state.emailAddress.toLowerCase().trim() },
      this.validateAndSubmit
    );
  }

  render() {
    const organizationNames = this.organizations.map((organization: any) => organization.name);
    const { emailAddress, organizationName, errors } = this.state;
    const { history: { goBack } } = this.props;

    return (
      <PageContainer>
        <div className={styles.formContainer}>
          <h1>Invite user</h1>
          <form>
            <div>
              <div>
                <LabeledInput
                  label='User email'
                  placeholder='Type the email of the user you like to invite'
                  onChange={this.handleEmailChange}
                  value={emailAddress}
                  error={errors.email}
                />
                <LabeledInput
                  label='New organization'
                  placeholder='Type the name of the organization'
                  onChange={this.handleOrganizationNameChange}
                  value={organizationName}
                  error={errors.organization}
                />
              </div>
              <div>
                <LabeledDropdown
                  key={this.dropDownKey}
                  options={organizationNames}
                  label='Or choose existing'
                  onSelect={this.onDropDownSelect}
                  error={errors.organization}
                />
              </div>
            </div>
            <div className={styles.buttonsContainer}>
              <Button
                type='cancel'
                onClick={goBack}
              >
                Cancel
              </Button>
              <Button
                type='submit'
                style={{ marginLeft: 20 }}
                onClick={this.handleSubmit}
              >
                Send Invitation
              </Button>
            </div>
          </form>
        </div>
      </PageContainer>
    );
  }
}

export default inject(GENERAL_STORE, USER_STORE)(InviteUserPage);
